import {styled} from "@mui/material/styles";
import Tooltip, {tooltipClasses} from '@mui/material/Tooltip';
import React from "react";

export const RaikoCustomTooltip = ({title, children}) => {

    const BootstrapTooltip = styled(({className, ...props}) => (
        <Tooltip {...props} arrow classes={{popper: className}}/>
    ))(({theme}) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: theme.palette.common.black,
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: theme.palette.common.black,
        },
    }));


    return (
        <BootstrapTooltip title={title}>
            {children}
        </BootstrapTooltip>
    )
}